import React, { FC, useMemo } from 'react'
import { GoogleLogo } from '@usap/uicomponents'
import { oauthConfig } from '../../../../MyAccount/SocialLogin/config'
import useSocialLoginEnabled from '../../../../../hooks/useSocialLogin'
import GTM from '../../../../../helpers/GTM'
import { OrDivider, SocialButtonsRow, SocialButton } from './LoyaltySignInModal.css'

type Props = {
  buttonText: string
  form: string
  // Optional extra tracking fired alongside socialLoginEngagement
  // (e.g. cart_login_up_google_cta_engagement on the Sign In view).
  onEngagement?: () => void
  dividerBelow?: boolean
}

const LoyaltySocialButtons: FC<Props> = ({ buttonText, form, onEngagement, dividerBelow = false }) => {
  const isSocialLoginEnabled = useSocialLoginEnabled()
  const { socialLoginEngagement } = GTM as any

  const googleOAuthURL = useMemo(() => {
    const { url, options } = oauthConfig()
    if (options) {
      const qs = new URLSearchParams(options as any)
      return `${url}?${qs.toString()}`
    }
    return ''
  }, [])

  if (!isSocialLoginEnabled) return null

  const button = (
    <SocialButtonsRow>
      <SocialButton
        href={googleOAuthURL}
        onClick={() => {
          socialLoginEngagement({ providerId: 'GOOGLE', buttonText, form })
          onEngagement?.()
        }}
      >
        <GoogleLogo />
        {buttonText}
      </SocialButton>
    </SocialButtonsRow>
  )

  return dividerBelow ? (
    <>
      {button}
      <OrDivider>OR</OrDivider>
    </>
  ) : (
    <>
      <OrDivider>OR</OrDivider>
      {button}
    </>
  )
}

export default LoyaltySocialButtons
